<template>
  <div
    id="app"
    :class="{
      'print-mode': $root.$data.printMode,
      'force-mobile': forceMobile,
      'force-desktop': forceDesktop,
      embedded: $root.$data.embedded,
    }"
  >
    <HeaderComponent :project="project" :hostAddress="hostAddress" @restart-map="restartMap" />

    <GdprPopup />
    <router-view />
  </div>
</template>

<script>
import GdprPopup from "./components/GdprPopup";
import HeaderComponent from "./components/HeaderComponent";
import M2wApi from "@/services/m2w_api";
import Vue from "vue";

export default {
  components: {GdprPopup, HeaderComponent},
  data() {
    return {
      forceMobile: false,
      forceDesktop: false,
      hostAddress: M2wApi.host_address,
      project: Vue.config.project,
    };
  },
  created() {
    let mobile = this.$route.query["mobile"];
    if (mobile) {
      let parsed = mobile.toLowerCase() === "true";
      this.forceMobile = parsed;
      this.forceDesktop = !parsed;
    }

    let embedded = this.$route.query["embedded"];
    this.$root.$data.embedded = !!embedded && embedded.toLowerCase() === "true";
  },
  watch: {
    "$i18n.locale": function (locale) {
      document.querySelector("html").setAttribute("lang", locale);
    },
  },
  methods: {
    restartMap() {
      this.$root.$emit("restartMapFromHeader");
    },
  },
};
</script>

<style lang="scss">
@import "assets/css/reset.css";
@import "~ol/ol.css";
@import "~ol-ext/control/Profil.css";

@import "assets/css/icons";
@import "assets/css/basemap";
@import "assets/css/bottom-bar";
@import "assets/css/menu-popup";
@import "assets/css/search-frame";
@import "assets/css/menu-component";
@import "assets/css/category-frame";
@import "assets/css/control-popup";
@import "assets/css/single-poi";
@import "assets/css/poi-data";
@import "assets/css/streets-popup";
@import "assets/css/right-click-frame";
@import "assets/css/measure-frame";
@import "assets/css/routing/main";
@import "assets/css/routing/drive-options";
@import "assets/css/routing/steps-frame";
@import "assets/css/settings-frame";
@import "assets/css/startup";
@import "assets/css/legend";
@import "assets/css/print";
</style>
